import { AppNS } from 'app';

import { getParentsByDisciplines } from '../disciplines-picker/validation-schema';

export interface ProfileAcknowledgement {
  id: AppNS.AcknowledgementId;
  name: string;
  fieldName: AppNS.AcknowledgementId;
  text: JSX.Element;
  parents: AppNS.DisciplineAgencyType[];
}

export const getAcknowledgementsByParents = (parents: AppNS.DisciplineAgencyType[]): ProfileAcknowledgement[] => {
  return ACKNOWLEDGEMENTS.filter((document) => parents.some((parent) => document.parents.includes(parent)));
};

export const getAcknowledgementsByDisciplines = (disciplines: AppNS.DisciplineId[]): ProfileAcknowledgement[] => {
  if (!disciplines || disciplines.length === 0) {
    return ACKNOWLEDGEMENTS;
  }

  const types = getParentsByDisciplines(disciplines);
  return getAcknowledgementsByParents(types);
};

export const ACKNOWLEDGEMENTS: ProfileAcknowledgement[] = [
  {
    id: 'conflictsOfInterest',
    name: 'Acknowledgement',
    fieldName: 'conflictsOfInterest',
    parents: [
      'regulatoryCode',
      'planReview',
      'specialInspections',
      'elevatorInspection',
      'commercialBoiler',
      'doee',
      'greenBuilding',
    ],
    text: (
      <>
        The Third-Party Agency, Professional-in-Charge, Inspector, Plan Reviewer, and other staff may not be a member
        of, financially associated with, or share common ownership or control with any property owner, construction
        firm, or design firm involved in the design or construction of any project for which the Third-Party Agency is
        contracted.
      </>
    ),
  },
  {
    id: 'directContract',
    name: 'Acknowledgement',
    fieldName: 'directContract',
    parents: [
      'regulatoryCode',
      'planReview',
      'specialInspections',
      'elevatorInspection',
      'commercialBoiler',
      'doee',
      'greenBuilding',
    ],
    text: <>The Third-Party Agency must contract directly with the property owner for each project.</>,
  },
  {
    id: 'staffConflictsOfInterest',
    name: 'Acknowledgement',
    fieldName: 'staffConflictsOfInterest',
    parents: [
      'regulatoryCode',
      'planReview',
      'specialInspections',
      'elevatorInspection',
      'commercialBoiler',
      'doee',
      'greenBuilding',
    ],
    text: (
      <>
        The Third-Party Agency, Professional-in-Charge, Inspector, Plan Reviewer, and other staff shall not have any
        other conflicts of interest on any project for which the Third-Party Agency is contracted.
      </>
    ),
  },
  {
    id: 'thirdPartyProgramProceduralManual',
    name: 'Acknowledgement',
    fieldName: 'thirdPartyProgramProceduralManual',
    parents: ['regulatoryCode', 'planReview', 'specialInspections', 'elevatorInspection', 'doee', 'greenBuilding'],
    text: (
      <>
        I have read and agree to adhere to the requirements of the{' '}
        <a target="_blank" rel="noreferrer" href="https://dob.dc.gov/node/1615846">
          Third-Party Program Procedural Manual
        </a>{' '}
        as amended.
      </>
    ),
  },
  {
    id: 'dcConstructionCodes',
    name: 'Acknowledgement',
    fieldName: 'dcConstructionCodes',
    parents: [
      'regulatoryCode',
      'planReview',
      'specialInspections',
      'elevatorInspection',
      'commercialBoiler',
      'doee',
      'greenBuilding',
    ],
    text: (
      <>
        I have read and agree to adhere to the requirements of the current edition of the{' '}
        <a target="_blank" rel="noreferrer" href="https://dob.dc.gov/page/dc-construction-codes">
          DC Construction Codes
        </a>{' '}
        with Amendments
      </>
    ),
  },
  {
    id: 'responsibilityCompliance',
    name: 'Acknowledgement',
    fieldName: 'responsibilityCompliance',
    parents: [
      'regulatoryCode',
      'planReview',
      'specialInspections',
      'elevatorInspection',
      'commercialBoiler',
      'doee',
      'greenBuilding',
    ],
    text: (
      <>
        I acknowledge that I am responsible for ensuring compliance with the foregoing as long as the Third-Party Agency
        is certified by the Department of Buildings.
      </>
    ),
  },
];
